<!--
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-08-22 14:30:49
 * @LastEditTime: 2019-09-04 09:44:43
 * @LastEditors: yingbin
 -->
<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
}
#app{
   height: 100vh;
   overflow-y:auto;
}
::-webkit-scrollbar {
  width:12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  box-shadow:inset006pxrgba(0,0,0,0.3);
  border-radius:10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius:10px;
  background:#C0C4CC;
  box-shadow:inset006pxrgba(0,0,0,0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background:#C0C4CC;
}
</style>

